export function navigateToLogin(from: ReturnType<typeof useRoute>) {
  return navigateTo({
    path: "/login",
    query: {
      redirectTo: encodeURIComponent(from.fullPath),
    },
  });
}
